module.exports = __webpack_public_path__ + "03_bob_brown.e13069b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/03_bob_brown.png
// module id = A4f6
// module chunks = 0